var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
var RangeOutput = React.forwardRef(function (_a, ref) {
    var rangeModel = _a.rangeModel, className = _a.className, style = _a.style, otherProps = __rest(_a, ["rangeModel", "className", "style"]);
    var classRangeOutput = "fr-range__output";
    if (className) {
        classRangeOutput += " " + className;
    }
    var translateX = rangeModel.getRatio() * rangeModel.width;
    var centerPercent = rangeModel.getRatio() * 100;
    var styleRangeOutput = __assign(__assign({}, style), { transform: "translateX(".concat(translateX, "px) translateX(-").concat(centerPercent, "%)") });
    return (React.createElement("span", __assign({}, otherProps, { className: classRangeOutput, style: styleRangeOutput, ref: ref }), rangeModel.getRangeString()));
});
export default RangeOutput;
